import React from 'react'
import AIChatMessage from '../../../../model2/ai/chat-message/chat-message'
import AiChatModule from '../../ai-chat'
import AIChatMessage_Collection from "../../../../model2/ai/chat-message/collection";
import AIChatMessage_Item from '../../../../../app/ai-chat/components/chat/message/chat-message';


type Props = {
    module      : AiChatModule
    messages    : AIChatMessage[]
    thinking    : boolean
}

export default function WriteWithAiChat_Messages(props: Props) {

    // let collectMessages = false

    // let thinkingMessageCollection   : AIChatMessage_Collection = new AIChatMessage_Collection([])
    let debugMessageCollection      : AIChatMessage_Collection = new AIChatMessage_Collection([])

    return (
        <div className="flex-column-left-top fl-gap-15 w-100p p-b-30">
            {_.map(props.messages, (message: AIChatMessage, key: number) => {

                if (message.isQuery) {
                    debugMessageCollection.reset()
                    debugMessageCollection.add(message)
                    // collectMessages = true

                    return (
                        <AIChatMessage_Item
                            key     = {message.id + '_' + key}
                            module  = {props.module}
                            message = {message}
                        />
                    )
                }

                if (
                    message.isChatName
                    || message.isToolSelection
                    || message.isBackendAiTurnsExited
                    || message.isCompaction
                    || message.isContext
                    || message.isAiVectorGeneration
                ) {
                    debugMessageCollection.add(message)
                    // collectMessages = true
                }

                if (
                    message.isToolsCallsRequest
                    || message.isToolsCallsResponse
                ) {
                    // Collect here
                    // thinkingMessageCollection.add(message)
                    debugMessageCollection.add(message)

                    // // If next message answer need render collection
                    // if (props.messages[key + 1].isAnswer) {
                    //
                    //     // collectMessages = false
                    //
                    //     const messageCollection = _.cloneDeep(thinkingMessageCollection)
                    //
                    //     return (
                    //         <ThinkingMessages
                    //             key                 = {key}
                    //             messageCollection   = {messageCollection}
                    //             answerTime          = {props.messages[key + 1].answerTime}
                    //         />
                    //     )
                    // }
                }

                if (
                    message.isAnswer
                    || message.isError
                ) {

                    debugMessageCollection.add(message)

                    const debugCollection = _.cloneDeep(debugMessageCollection)

                    // thinkingMessageCollection.reset()

                    // to test insert in editor
                    props.module.currentAiMessage = message

                    return (
                        <AIChatMessage_Item
                            key                     = {message.id + '_' + key}
                            module                  = {props.module}
                            debugMessageCollection  = {debugCollection}
                            message                 = {message}
                        />
                    )
                }

            })}

            {props.thinking && (
                <div className="flex-row-left-center m-t-10 m-b-10">
                    <div className="i5-default-ai ui5-color-action m-r-5"></div>
                    <div className="ui5-txt-less-important pre-line">
                        Thinking ...
                    </div>
                </div>
            )}
        </div>
    )
}
